import { reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import { formatDate, breakComma, isPc } from '@/util/common'
import * as _ from 'lodash'
import { openPrecedentListWithRevisionID } from '@/logic/common/CommonPrecedent'

export const AlertList = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { alert } = store.state

  onBeforeMount(() => {
    // 初回リスト読み込み
    action.load()
  })

  const data = reactive({
    // 日付でソートされたリスト
    lists: computed(() => alert.lists),
    count: computed(() => alert.count),
    // 絞り込みはAPI側で実行するため、日付のグルーピングのみおこなう
    groupDateLists: computed(() => _.groupBy(data.lists, 'date')),
    // 全読み込み済みフラグ
    complete: computed(() => alert.complete),
    canload: computed(() => alert.canload)
  })

  const state = reactive({
    visibleToast: false,
    visibleAlertListDeleteConfirm: false,
    visibleAlertListDeleteInBulkConfirm: false,
    visibleProfile: false,
    additionalLoading: true,
    canload: true
  })

  const openProfile = () => {
    state.visibleProfile = true
  }

  const action = {
    load: () => {
      store.dispatch('alert/getLists')
    },
    deleteItem: (id) => {
      store.dispatch('alert/setEditId', id)
      state.visibleAlertListDeleteConfirm = true
    },
    routeList: (list) => {
      // 遷移先とstoreのアクション名を設定
      switch (list.type) {
        case 'qa':
          if (isPc()) {
            router.push({ name: 'PCQADetail', params: { qaId: list.id } })
          } else {
            router.push({ name: 'SPQADetail', params: { qaId: list.id } })
          }
          break
        case 'knowledge':
          if (isPc()) {
            router.push({ name: 'PCKnowledgeDetail', params: { knowledgeId: list.id } })
          } else {
            router.push({ name: 'SPKnowledgeDetail', params: { knowledgeId: list.id } })
          }
          break
        case 'pj':
          // 資料検索の一覧画面を書籍リビジョン指定で開く
          openPrecedentListWithRevisionID(list.book_revision_id)
          break
      }
    }
  }

  return {
    state,
    data,
    formatDate,
    breakComma,
    openProfile,
    action
  }
}
